export const STORE_KEY = '__READ_CAMPAIGN_DETAILS__';
export const INITIAL_STATE = {
    error: false,
    loading: false,
    campaign: undefined,
};
